import { TContentHubButton, StringField, ComponentParamsGeneral } from '../../../types/types';
import { TSummarySpecUpdated, TContentHubProductModelDetailHeroSectionFields } from '../types/productModelDetailHeroSection.types';
import { THeroSectionTextProps } from '../types/heroSectionText.types';
import { appendRootToRichTextInternalLinks } from '../../../utils/appendRootToRichTextInternalLinks.utils';
import { appendRootToInternalLink } from '../../../utils/appendRootToInternalLink.utils';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-react';

export class HeroSectionTextModel {
  private readonly fields?: TContentHubProductModelDetailHeroSectionFields;
  private readonly componentRendering?: ComponentRendering;
  private readonly params?: ComponentParamsGeneral;

  constructor(props: THeroSectionTextProps) {
    this.fields = props?.fields || null;
    this.componentRendering = props?.rendering;
    this.params = props?.params;
  }

  get eyebrow(): StringField {
    return { value: this.fields?.apiData?.eyebrow };
  }

  get title(): StringField {
    return { value: this.fields?.apiData?.title };
  }

  get description(): StringField {
    return {
      value: appendRootToRichTextInternalLinks(this.fields?.apiData?.description),
    };
  }

  get primaryLink(): TContentHubButton | undefined {
    return this.fields?.apiData?.button1;
  }

  get primaryCTAUrl(): string | undefined {
    return appendRootToInternalLink(this?.primaryLink?.url);
  }

  get secondaryLink(): TContentHubButton | undefined {
    return this.fields?.apiData?.button2;
  }

  get summarySpecs(): Array<TSummarySpecUpdated> {
    return (
      this.fields?.apiData?.summarySpecs
        ?.filter((spec) => spec.active)
        .map((spec) => {
          return { key: { value: spec.key }, value: { value: spec.value } };
        }) || []
    );
  }

  get optionalLabel(): StringField {
    return { value: this.fields?.apiData?.optionalLabel };
  }

  get msrp(): StringField {
    return { value: this.fields?.apiData?.msrp || '' };
  }

  get placeholderCtaTitle(): string {
    const componentRendering = this.componentRendering?.placeholders?.['jss-generic-popup']?.[0] as ComponentRendering;
    return componentRendering?.params?.['ctaText'] ?? '';
  }

  get enableBuildPriceCTA(): boolean | undefined {
    return this.params?.enableBuildPriceCTA === '1';
  }
}
